module.exports = __webpack_public_path__ + "img/moti_4.77e0e490.png";